import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment';
import { Row, Col } from 'antd';
import { Animated } from "react-animated-css";
import Top10SeriesCard from '../../components/analytics/top10seriescard';
import Top10MovieCard from '../../components/analytics/top10moviecard';
import FirstClickRanking from '../../components/recommendation/firstclickranking';
import Top10PurchaseContent from '../../components/recommendation/top10purchasecontent';
import Top10RentContent from '../../components/recommendation/top10rentcontent';
import Top10ShareContent from '../../components/recommendation/top10sharecontent';
import Top10DownloadContent from '../../components/recommendation/top10downloadcontent';
import Top10AddWatchlistContent from '../../components/recommendation/top10addwatchlistcontent';
import Top10DeleteWatchlistContent from '../../components/recommendation/top10deletewatchlistcontent';
import Top10MovieTrailerCard from '../../components/recommendation/top10movietrailercard';
import Top10SeriesTrailerCard from '../../components/recommendation/top10seriestrailercard';

import './Recommendation.css';

import {
	opensearchFiratClickRanking,
	opensearchTop10PurchaseContent,
	opensearchTop10RentContent,
	opensearchTop10ShareContent,
	opensearchTop10DownloadContent,
	opensearchTop10AddWatchlistContent,
	opensearchTop10DeleteWatchlistContent,
	opensearchTop10MovieTrailer,
	opensearchTop10SeriesTrailer

} from '../../modules/recommendation';

import {
	opensearchTop10Movie,
	opensearchTop10Series,
	opensearchMovieAll,
	opensearchSeriesAll,
} from '../../modules/analytics';

class Recommendation extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loading:false
		}
	}

	async componentDidMount() {
		const {  opensearchFisrtClickList, opensearchTop10PurchaseContentList,opensearchTop10RentContentList, opensearchTop10ShareContentList,opensearchTop10DownloadContentList,opensearchTop10AddWatchlistContentList,opensearchTop10DeleteWatchlistContentList,
			opensearchTop10MovieTrailerList,opensearchTop10SeriesTrailerList,opensearchTop10SeriesList, opensearchTop10MovieList, opensearchMovieList, opensearchSeriesList} = this.props;
		
		if(!opensearchFisrtClickList){
			this.getOpensearchFirstClickList();
		}
		if(!opensearchTop10PurchaseContentList){
			this.getOpensearchTop10PurchaseList();
		}
		if(!opensearchTop10RentContentList){
			this.getOpensearchTop10RentList();
		}
		if(!opensearchTop10ShareContentList){
			this.getOpensearchTop10ShareList();
		}
		if(!opensearchTop10DownloadContentList){
			this.getOpensearchTop10DownloadList();
		}
		if(!opensearchTop10AddWatchlistContentList){
			this.getOpensearchTop10AddWatchlistList();
		}
		if(!opensearchTop10DeleteWatchlistContentList){
			this.getOpensearchTop10DeleteWatchlistList();
		}
		if(!opensearchTop10SeriesList){
			this.getOpensearchTop10SeriesList();
		}
		if(!opensearchTop10MovieList){
			this.getOpensearchTop10MovieList();
		}
		if(!opensearchMovieList){
			this.getOpenMovieList();
		}
		if(!opensearchSeriesList){
			this.getOpenSeriesList();
		}if(!opensearchTop10MovieTrailerList){
			this.getOpensearchTop10MovieTrailerList();
		}if(!opensearchTop10SeriesTrailerList){
			this.getOpensearchTop10SeriesTrailerList();
		}
		
		

	}

	async componentDidUpdate(prevProps) {
		const {  opensearchFisrtClickList, opensearchTop10PurchaseContentList,opensearchTop10RentContentList, opensearchTop10ShareContentList,opensearchTop10DownloadContentList,opensearchTop10AddWatchlistContentList,opensearchTop10DeleteWatchlistContentList,
			opensearchTop10MovieTrailerList,opensearchTop10SeriesTrailerList,opensearchTop10SeriesList, opensearchTop10MovieList,opensearchMovieList, opensearchSeriesList } = this.props;

		if(!opensearchFisrtClickList && JSON.stringify(opensearchFisrtClickList) !== JSON.stringify(prevProps.opensearchFisrtClickList)){
			this.getOpensearchFirstClickList();
		}
		if(!opensearchTop10PurchaseContentList && JSON.stringify(opensearchTop10PurchaseContentList) !== JSON.stringify(prevProps.opensearchTop10PurchaseContentList)){
			this.getOpensearchTop10PurchaseList();
		}
		if(!opensearchTop10RentContentList && JSON.stringify(opensearchTop10RentContentList) !== JSON.stringify(prevProps.opensearchTop10RentContentList)){
			this.getOpensearchTop10RentList();
		}
		if(!opensearchTop10ShareContentList && JSON.stringify(opensearchTop10ShareContentList) !== JSON.stringify(prevProps.opensearchTop10ShareContentList)){
			this.getOpensearchTop10ShareList();
		}
		if(!opensearchTop10DownloadContentList && JSON.stringify(opensearchTop10DownloadContentList) !== JSON.stringify(prevProps.opensearchTop10DownloadContentList)){
			this.getOpensearchTop10DownloadList();
		}
		if(!opensearchTop10AddWatchlistContentList && JSON.stringify(opensearchTop10AddWatchlistContentList) !== JSON.stringify(prevProps.opensearchTop10AddWatchlistContentList)){
			this.getOpensearchTop10AddWatchlistList();
		}
		if(!opensearchTop10DeleteWatchlistContentList && JSON.stringify(opensearchTop10AddWatchlistContentList) !== JSON.stringify(prevProps.opensearchTop10AddWatchlistContentList)){
			this.getOpensearchTop10DeleteWatchlistList();
		}
		if(!opensearchTop10SeriesList && JSON.stringify(opensearchTop10SeriesList) !== JSON.stringify(prevProps.opensearchTop10SeriesList)){
			this.getOpensearchTop10SeriesList();
		}
		if(!opensearchTop10MovieList && JSON.stringify(opensearchTop10MovieList) !== JSON.stringify(prevProps.opensearchTop10MovieList)){
			this.getOpensearchTop10MovieList();
		}
		if(!opensearchMovieList && JSON.stringify(opensearchMovieList) !== JSON.stringify(prevProps.opensearchMovieList)){
			this.getOpenMovieList();
		}
		if(!opensearchSeriesList && JSON.stringify(opensearchSeriesList) !== JSON.stringify(prevProps.opensearchSeriesList)){
			this.getOpenSeriesList();
		}
		if(!opensearchTop10MovieTrailerList && JSON.stringify(opensearchTop10MovieTrailerList) !== JSON.stringify(prevProps.opensearchTop10MovieTrailerList)){
			this.getOpensearchTop10MovieTrailerList();
		}
		if(!opensearchTop10SeriesTrailerList && JSON.stringify(opensearchTop10SeriesTrailerList) !== JSON.stringify(prevProps.opensearchTop10SeriesTrailerList)){
			this.getOpensearchTop10SeriesTrailerList();
		}

	}

	getOpensearchFirstClickList = async () => {
		const { selectedOrganization, inspectionTime } = this.props;
		this.setState({ loading: true });
		await this.props.opensearchFiratClickRanking(`accountName=${selectedOrganization}&gte=${moment(inspectionTime.till).subtract(inspectionTime.day, 'days').toISOString()}&lte=${moment(inspectionTime.till).toISOString()}`);
		this.setState({ loading: false });
	}
	getOpensearchTop10PurchaseList = async () => {
		const { selectedOrganization, inspectionTime } = this.props;
		this.setState({ loading: true });
		await this.props.opensearchTop10PurchaseContent(`accountName=${selectedOrganization}&gte=${moment(inspectionTime.till).subtract(inspectionTime.day, 'days').toISOString()}&lte=${moment(inspectionTime.till).toISOString()}`);
		this.setState({ loading: false });
	}
	getOpensearchTop10RentList = async () => {
		const { selectedOrganization, inspectionTime } = this.props;
		this.setState({ loading: true });
		await this.props.opensearchTop10RentContent(`accountName=${selectedOrganization}&gte=${moment(inspectionTime.till).subtract(inspectionTime.day, 'days').toISOString()}&lte=${moment(inspectionTime.till).toISOString()}`);
		this.setState({ loading: false });
	}
	getOpensearchTop10ShareList = async () => {
		const { selectedOrganization, inspectionTime } = this.props;
		this.setState({ loading: true });
		await this.props.opensearchTop10ShareContent(`accountName=${selectedOrganization}&gte=${moment(inspectionTime.till).subtract(inspectionTime.day, 'days').toISOString()}&lte=${moment(inspectionTime.till).toISOString()}`);
		this.setState({ loading: false });
	}
	getOpensearchTop10DownloadList = async () => {
		const { selectedOrganization, inspectionTime } = this.props;
		this.setState({ loading: true });
		await this.props.opensearchTop10DownloadContent(`accountName=${selectedOrganization}&gte=${moment(inspectionTime.till).subtract(inspectionTime.day, 'days').toISOString()}&lte=${moment(inspectionTime.till).toISOString()}`);
		this.setState({ loading: false });
	}
	getOpensearchTop10AddWatchlistList = async () => {
		const { selectedOrganization, inspectionTime } = this.props;
		this.setState({ loading: true });
		await this.props.opensearchTop10AddWatchlistContent(`accountName=${selectedOrganization}&gte=${moment(inspectionTime.till).subtract(inspectionTime.day, 'days').toISOString()}&lte=${moment(inspectionTime.till).toISOString()}`);
		this.setState({ loading: false });
	}
	getOpensearchTop10DeleteWatchlistList = async () => {
		const { selectedOrganization, inspectionTime } = this.props;
		this.setState({ loading: true });
		await this.props.opensearchTop10DeleteWatchlistContent(`accountName=${selectedOrganization}&gte=${moment(inspectionTime.till).subtract(inspectionTime.day, 'days').toISOString()}&lte=${moment(inspectionTime.till).toISOString()}`);
		this.setState({ loading: false });
	}
	getOpensearchTop10MovieList = async () => {
		const { selectedOrganization, inspectionTime } = this.props;
		this.setState({ loadingnewuser: true });
		await this.props.opensearchTop10Movie(`accountName=${selectedOrganization}&gte=${moment(inspectionTime.till).subtract(inspectionTime.day, 'days').toISOString()}&lte=${moment(inspectionTime.till).toISOString()}`);
		this.setState({ loadingnewuser: false });
	}
	getOpensearchTop10SeriesList = async () => {
		const { selectedOrganization, inspectionTime } = this.props;
		this.setState({ loadingtopwatch: true });
		await this.props.opensearchTop10Series(`accountName=${selectedOrganization}&gte=${moment(inspectionTime.till).subtract(inspectionTime.day, 'days').toISOString()}&lte=${moment(inspectionTime.till).toISOString()}`);
		this.setState({ loadingtopwatch: false });
	}
	getOpenMovieList = async () => {
		const { selectedOrganization, inspectionTime } = this.props;
		this.setState({ loadingtopwatch: true });
		await this.props.opensearchMovieAll(`accountName=${selectedOrganization}&gte=${moment(inspectionTime.till).subtract(inspectionTime.day, 'days').toISOString()}&lte=${moment(inspectionTime.till).toISOString()}`);
		this.setState({ loadingtopwatch: false });
	}
	getOpenSeriesList = async () => {
		const { selectedOrganization, inspectionTime } = this.props;
		this.setState({ loadingtopwatch: true });
		await this.props.opensearchSeriesAll(`accountName=${selectedOrganization}&gte=${moment(inspectionTime.till).subtract(inspectionTime.day, 'days').toISOString()}&lte=${moment(inspectionTime.till).toISOString()}`);
		this.setState({ loadingtopwatch: false });
	}
	getOpensearchTop10MovieTrailerList = async () => {
		const { selectedOrganization, inspectionTime } = this.props;
		this.setState({ loadingtopwatch: true });
		await this.props.opensearchTop10MovieTrailer(`accountName=${selectedOrganization}&gte=${moment(inspectionTime.till).subtract(inspectionTime.day, 'days').toISOString()}&lte=${moment(inspectionTime.till).toISOString()}`);
		this.setState({ loadingtopwatch: false });
	}
	getOpensearchTop10SeriesTrailerList = async () => {
		const { selectedOrganization, inspectionTime } = this.props;
		this.setState({ loadingtopwatch: true });
		await this.props.opensearchTop10SeriesTrailer(`accountName=${selectedOrganization}&gte=${moment(inspectionTime.till).subtract(inspectionTime.day, 'days').toISOString()}&lte=${moment(inspectionTime.till).toISOString()}`);
		this.setState({ loadingtopwatch: false });
	}

	render() {
		const {loading } = this.state;

		return (
			<Animated animationIn="fadeIn">
				<div className="mainContentWrapper" style={{ paddingBottom: (this.props.play) ? '100px' : '20px' }}>
					<Row>
						<Col md={24} lg={24} xl={24} xxl={24}>
								<Row>
									 <Col span={24}>
									 	<Top10MovieCard loading={loading}/>
									</Col>
								</Row>
								<Row>
									 <Col span={24}>
									 	<Top10MovieTrailerCard loading={loading}/>
									</Col>
								</Row>
								<Row>
									 <Col span={24}>
										<Top10SeriesCard loading={loading}/>
									</Col>
								</Row>
								<Row>
									 <Col span={24}>
										<Top10SeriesTrailerCard loading={loading}/>
									</Col>
								</Row>
								<Row>
									 <Col span={24}>
										<FirstClickRanking loading={loading}/>
									</Col>
								</Row>
								<Row>
									 <Col span={12}>
										<Top10PurchaseContent loading={loading}/>
									</Col>
									<Col span={12}>
										<Top10RentContent loading={loading}/>
									</Col>
								</Row>
								<Row>
									 <Col span={12}>
										<Top10ShareContent loading={loading}/>
									</Col>
									<Col span={12}>
										<Top10DownloadContent loading={loading}/>
									</Col>
								</Row>
								<Row>
									 <Col span={12}>
										<Top10AddWatchlistContent loading={loading}/>
									</Col>
									<Col span={12}>
										<Top10DeleteWatchlistContent loading={loading}/>
									</Col>
								</Row>
								
								
						</Col>
					</Row>
				</div>
			</Animated>
		);
	}


}

const mapStateToProps = state => ({
	router: state.router,
	userProfile: state.user.userProfile,
	selectedOrganization: state.user.selectedOrganization,
	inspectionTime: state.analytics.inspectionTime,
	opensearchTop10MovieList : state.analytics.opensearchTop10MovieList,
	opensearchTop10SeriesList : state.analytics.opensearchTop10SeriesList,
	opensearchMovieList : state.analytics.opensearchMovieList,
	opensearchSeriesList : state.analytics.opensearchSeriesList,
	opensearchFisrtClickList : state.recommendation.opensearchFisrtClickList,
	opensearchTop10PurchaseContentList : state.recommendation.opensearchTop10PurchaseContentList,
	opensearchTop10RentContentList : state.recommendation.opensearchTop10RentContentList,
	opensearchTop10ShareContentList : state.recommendation.opensearchTop10ShareContentList,
	opensearchTop10DownloadContentList : state.recommendation.opensearchTop10DownloadContentList,
	opensearchTop10AddWatchlistContentList : state.recommendation.opensearchTop10AddWatchlistContentList,
	opensearchTop10DeleteWatchlistContentList : state.recommendation.opensearchTop10DeleteWatchlistContentList,
	opensearchTop10MovieTrailerList : state.recommendation.opensearchTop10MovieTrailerList,
	opensearchTop10SeriesTrailerList : state.recommendation.opensearchTop10SeriesTrailerList
	
	
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			opensearchFiratClickRanking,
			opensearchTop10PurchaseContent,
			opensearchTop10RentContent,
			opensearchTop10ShareContent,
			opensearchTop10DownloadContent,
			opensearchTop10AddWatchlistContent,
			opensearchTop10DeleteWatchlistContent,
			opensearchTop10Movie,
			opensearchTop10Series,
			opensearchMovieAll,
			opensearchSeriesAll,
			opensearchTop10MovieTrailer,
			opensearchTop10SeriesTrailer
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps)(Recommendation);
